export default "/images/9385d32b06439895755a7da6eb66d84a.avif";